import React from "react";

function TemplateSelector({
  templates,
  selectedTemplateShortName,
  onSelect,
  disabled,
}) {
  return (
    <div className="activity-creation-template-bar formGroup mrNone" data-test="activity-form-template-bar">
      <span className="activity-creation-template-bar-label wth-1">
        You have selected
      </span>
      <select
        data-test="activity-form-template-select"
        value={selectedTemplateShortName ?? ""}
        onChange={(e) => onSelect(e.target.value || null)}
        disabled={disabled}
        className="activity-creation-template-select wth-3"
      >
        <option value="">Default</option>
        {templates.map((t) => (
          <option key={t.template_short_name} value={t.template_short_name}>
            {t.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default TemplateSelector;